import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import { DishFullInfoContext, IDishFullInfoContext } from '../../../../../../../dishFullInfoState/dishFullInfoContext';

const TranslationsField: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	const languages = dishForFullInfo?.customer?.languages.map((translation) => translation.name).join(', ');

	return <FullInfoField label="translationsLabel" value={languages} />;
};

export default TranslationsField;
